// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../.yarn/__virtual__/css-loader-virtual-85d6bada94/0/cache/css-loader-npm-7.1.1-25b990b98a-435a21f195.zip/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../.yarn/__virtual__/css-loader-virtual-85d6bada94/0/cache/css-loader-npm-7.1.1-25b990b98a-435a21f195.zip/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customfield {
  font-family: monospace;
  display: inline-block;
}`, "",{"version":3,"sources":["webpack://./assets/js/components/editorjs/components/tune-customfield-selector/index.css"],"names":[],"mappings":"AAAA;EACC,sBAAA;EACA,qBAAA;AACD","sourcesContent":[".customfield {\r\n\tfont-family: monospace;\r\n\tdisplay: inline-block;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
